import {DeserializedRecord, Deserializer, deserializeSingleRelationship, JSONAPIRecord, JSONAPISingleRelationship} from "../Helpers";
import {deserializeItem} from "../index";
import {deserializeTenantSubscription, TenantSubscription, TenantSubscriptionData} from "../tenant/TenantSubscription";
import {
  deserializeTenantItemPriceWithItem,
  TenantItemPriceWithItem,
  TenantItemPriceWithItemData
} from "../tenant/subscription/ItemPriceWithItem";
import {deserializePatient, Patient} from "../Patient";

type ActivationStatus = "active" | "inactive" | "pending";

interface PatientSubscription extends DeserializedRecord {
  chargebeeSubscriptionId: string;
  activationStatus: ActivationStatus;
  startAt?: Date;
  endAt?: Date;
  subscription: TenantSubscription;
  itemPricesWithItem: TenantItemPriceWithItem[],
  patient?: Patient
}

interface PatientSubscriptionData extends JSONAPIRecord {
  relationships: {
    patient: JSONAPISingleRelationship;
  } & JSONAPIRecord["relationships"],
  attributes: {
    subscription: {
      data: TenantSubscriptionData
    }
    item_prices_with_item?: {
      data: TenantItemPriceWithItemData[]
    }
  }
}


const deserializePatientSubscription: Deserializer<PatientSubscription, PatientSubscriptionData> = (data, included) => {
  const subscription = deserializeTenantSubscription(data.attributes.subscription.data);
  const itemPricesWithItem = data.attributes.item_prices_with_item?.data?.map((el) => deserializeTenantItemPriceWithItem(el));
  const patientSubscription = deserializeItem<PatientSubscription>(data);
  const patient = deserializeSingleRelationship<Patient>(data.relationships?.patient, included, deserializePatient);

  return {
    ...patientSubscription,
    subscription,
    itemPricesWithItem,
    patient: patient
  };
};

export {
  ActivationStatus,
  PatientSubscription,
  deserializePatientSubscription
};
